// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// EN - Common Files
import enValidation from '@gyandiksha/shared-ui/utils/languagedetector/locales/en/validation.json';
import enApiErrorResponse from '@gyandiksha/shared-ui/utils/languagedetector/locales/en/apiErrorResponse.json';
import enApiSuccessResponse from '@gyandiksha/shared-ui/utils/languagedetector/locales/en/apiSuccessResponse.json';

// GU - Common Files
import guValidation from '@gyandiksha/shared-ui/utils/languagedetector/locales/gu/validation.json';
import guApiErrorResponse from '@gyandiksha/shared-ui/utils/languagedetector/locales/gu/apiErrorResponse.json';
import guApiSuccessResponse from '@gyandiksha/shared-ui/utils/languagedetector/locales/gu/apiSuccessResponse.json';

i18n
    .use(LanguageDetector) // Detect user language
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        debug: false,

        // Use '.' as the namespace separator so t('login.key') → namespace: login, key: key
        // Use false for keySeparator since all JSON files have flat (non-nested) keys
        nsSeparator: '.',
        keySeparator: false,

        ns: [
            'common',
            'validation',
            "apiErrorResponse",
            "apiSuccessResponse"
        ],
        defaultNS: 'common',

        interpolation: {
            escapeValue: false,
        },

        resources: {
            en: {
                validation: enValidation,
                apiErrorResponse: enApiErrorResponse,
                apiSuccessResponse: enApiSuccessResponse
            },
            gu: {
                validation: guValidation,
                apiErrorResponse: guApiErrorResponse,
                apiSuccessResponse: guApiSuccessResponse
            },
        },
    });

export default i18n;